import { queryOptions } from '@tanstack/react-query';

import { getGovernanceAllQuery, getGovernanceQuery } from './shared';

export const getGovernanceQueryOptions = (id: string) => queryOptions(getGovernanceQuery(id));
export const getGovernanceAllQueryOptions = () => queryOptions(getGovernanceAllQuery());
